import styled from "styled-components";
import colors from "../../../../styles/colors";

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  padding: 20px;
  min-height: 400px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const PreviewContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 300px;

  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

export const FormContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 300px;

  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

interface CardPreviewProps {
  $primaryColor: string;
  $secondaryColor: string;
}

export const CardPreview = styled.div<CardPreviewProps>`
  width: 100%;
  max-width: 400px;
  aspect-ratio: 1.586 / 1;
  background: linear-gradient(
    135deg,
    ${props => props.$primaryColor} 0%,
    ${props => props.$secondaryColor} 100%
  );
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
  color: white;
  font-family: "Roboto", sans-serif;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    pointer-events: none;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
`;

export const CardChip = styled.div`
  width: 50px;
  height: 40px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
  border-radius: 8px;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

  &::before {
    content: "";
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: 8px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
  }
`;

export const CardBrandLogo = styled.div`
  font-size: 24px;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 1;
`;

export const CardNumber = styled.div`
  font-size: 24px;
  letter-spacing: 3px;
  font-weight: 500;
  margin-bottom: 20px;
  font-family: "Courier New", monospace;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
`;

export const CardHolderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  z-index: 1;
`;

export const CardLabel = styled.div`
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.8;
  margin-bottom: 4px;
`;

export const CardHolderName = styled.div`
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 20px;
  position: relative;
  z-index: 1;
`;

export const CardExpiry = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardExpiryValue = styled.div`
  font-size: 16px;
  font-weight: 500;
  font-family: "Courier New", monospace;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
`;

export const OpenModalButton = styled.button`
  padding: 12px 24px;
  background: ${colors.primary};
  color: ${colors.text.white};
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: ${colors.primaryDark};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const CardInfoTable = styled.table`
  width: 100%;
  margin-top: 16px;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const CardInfoRow = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid ${colors.background.dark};
  }

  &:hover {
    background-color: ${colors.background.light};
  }
`;

export const CardInfoLabel = styled.td`
  padding: 10px;
  font-weight: 500;
  color: ${colors.text.muted};
  font-size: 14px;
  width: 60%;
  vertical-align: top;
`;

export const CardInfoValue = styled.td`
  padding: 12px 10px;
  color: ${colors.text.primary};
  font-size: 14px;
  vertical-align: top;
`;
